import React, { useEffect, useState } from "react";
import client, { formatErr } from "../../lib/api";
import { toast } from "sonner";
import { Award, Zap, ChevronUp } from "lucide-react";

export default function AdminUsers() {
    const [users, setUsers] = useState([]);
    const [badges, setBadges] = useState([]);

    const load = () => {
        client.get("/admin/users", { params: { limit: 200 } }).then((r) => setUsers(r.data.items));
        client.get("/admin/badges").then((r) => setBadges(r.data));
    };

    useEffect(() => {
        load();
    }, []);

    const award = async (uid, payload) => {
        try {
            await client.post(`/admin/users/${uid}/award`, null, { params: payload });
            toast.success("Awarded");
            load();
        } catch (e) {
            toast.error(formatErr(e));
        }
    };

    return (
        <div>
            <span className="label-cap text-xs text-neon-orange">Users</span>
            <h1 className="font-display font-black text-4xl uppercase tracking-tight mt-1">Athletes</h1>

            <div className="mt-6 space-y-2">
                {users.map((u) => (
                    <div key={u.id} className="surface-1 p-4" data-testid={`adm-user-${u.id}`}>
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-neon-green/20 border border-neon-green flex items-center justify-center font-display font-black">
                                {u.name?.[0]?.toUpperCase()}
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="font-display font-bold uppercase text-sm leading-none truncate">{u.name}</div>
                                <div className="text-xs text-zinc-500 mt-1 truncate">{u.email}</div>
                            </div>
                            <div className="text-right">
                                <div className="font-display font-black text-lg text-neon-green">{u.xp} XP</div>
                                <div className="text-[10px] uppercase tracking-widest text-zinc-500">Lv {u.current_level}</div>
                            </div>
                        </div>
                        <div className="mt-3 flex flex-wrap gap-2">
                            <button
                                onClick={() => award(u.id, { xp: 100 })}
                                data-testid={`adm-user-xp-${u.id}`}
                                className="surface-3 px-3 py-1.5 label-cap text-[10px] flex items-center gap-1 hover:border-neon-green"
                            >
                                <Zap size={10} className="text-neon-green" /> +100 XP
                            </button>
                            <button
                                onClick={() => award(u.id, { level: u.current_level + 1 })}
                                data-testid={`adm-user-level-${u.id}`}
                                className="surface-3 px-3 py-1.5 label-cap text-[10px] flex items-center gap-1 hover:border-neon-orange"
                            >
                                <ChevronUp size={10} className="text-neon-orange" /> Level Up
                            </button>
                            {badges.length > 0 && (
                                <select
                                    onChange={(e) => {
                                        if (e.target.value) {
                                            award(u.id, { badge_id: e.target.value });
                                            e.target.value = "";
                                        }
                                    }}
                                    data-testid={`adm-user-badge-${u.id}`}
                                    className="surface-3 px-3 py-1.5 label-cap text-[10px] hover:border-neon-green bg-charcoal-700"
                                    defaultValue=""
                                >
                                    <option value="">+ Award Badge</option>
                                    {badges.map((b) => (
                                        <option key={b.id} value={b.id}>
                                            {b.name}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
